export default __webpack_public_path__ + "static/media/Poppins-BoldItalic.cfb635a5.ttf";